import type { UseQueryOptions } from '@tanstack/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';

import { createOrder, getOrders, getOrder } from './orders-api';
import type { FindOrdersRequestParams } from './orders-api';

import type { CreateOrderRequest, Order } from '../index';

export function useCreateOrderMutation() {
  return useMutation({
    mutationKey: ['create-order'],
    mutationFn: (order: CreateOrderRequest) => createOrder(order),
  });
}

export function useFindOrdersQuery(
  params: FindOrdersRequestParams,
  options: Omit<
    UseQueryOptions<unknown, Error, { orders: Order[]; total: number }>,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery({
    ...options,
    queryKey: ['find-orders', params],
    queryFn: async () => {
      const { items, pageInfo } = await getOrders(params);

      return {
        orders: items,
        total: pageInfo.total,
      };
    },
  });
}

export function useGetOrderByIdQuery(id: string) {
  return useQuery({
    queryKey: ['get-order', id],
    queryFn: async () => getOrder(id),
  });
}
